module.exports = __webpack_public_path__ + "static/media/minigame.732b92c2.svg";